import TYPES from '../../types';

// Domain
import { InvestmentProductFundTypeEntity } from '../../domain/entities/investment-product-fund-type-entity';
import { InvestmentProductFundTypeRepository } from '../../domain/repositories/investment-product-fund-type-repository';
import { InvestmentProductFundTypeStateManager } from '../../domain/state/investment-product-fund-type-state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class GetInvestmentProductFundTypeQuery extends
  Query<Promise<Array<InvestmentProductFundTypeEntity>>> {
  @Inject(TYPES.INVESTMENT_PRODUCT_FUND_TYPE_REPOSITORY)
  private readonly repository!: InvestmentProductFundTypeRepository;

  @Inject(TYPES.INVESTMENT_PRODUCT_FUND_TYPE_STATE_MANAGER)
  private readonly state_manager!: InvestmentProductFundTypeStateManager;

  internalExecute(): Promise<Array<InvestmentProductFundTypeEntity>> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.loaded) {
        resolve(this.state_manager.state.items);
      } else {
        this.repository.get()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      }
    });
  }
}
